import { IconChevronDown } from "@pentabd/icons";
import { Button, Input, Select, Text } from "@pentabd/ui";
import { useTranslation } from "react-i18next";

export default function FloorForm() {
  const { t } = useTranslation();
  return (
    <div className="bg-primary-lightest rounded p-12 my-12">
      <div className="pb-8">
        <Text color="#101828" component="h2" size="xl" weight="semibold">
          {t("INVENTORY_ROOM_CONFIG.FLOOR.FORM.LABEL")}
        </Text>
      </div>
      <div className="pt-8 border-top">
        <div className="row pb-0 mb-0">
          <div className="col-4">
            <Text
              color="#344054"
              component="p"
              size="md"
              weight="semibold"
              className="mb-6"
            >
              {t("INVENTORY_ROOM_CONFIG.FLOOR.FORM.FIELDS.FIELD_1.NAME")}
            </Text>
            <Select
              //   {...register(GENERAL_INFO.RELIGION)}
              options={[
                {
                  label: "label 1",
                  value: "label 1",
                },
                {
                  label: "label 1",
                  value: "label 1",
                },
                {
                  label: "label 1",
                  value: "label 1",
                },
                {
                  label: "label 1",
                  value: "label 1",
                },
                {
                  label: "label 1",
                  value: "label 1",
                },
              ]}
              defaultValue={"test"}
              name="category"
              onSelectItem={(e) => console.log(e)}
              suffix={<IconChevronDown size="16" />}
              placeholder={t(
                "INVENTORY_ROOM_CONFIG.FLOOR.FORM.FIELDS.FIELD_1.PLACEHOLDER",
              )}
            />
          </div>

          <div className="col-4">
            <Text
              color="#344054"
              component="p"
              size="md"
              weight="semibold"
              className="mb-6"
            >
              {t("INVENTORY_ROOM_CONFIG.FLOOR.FORM.FIELDS.FIELD_2.NAME")}
            </Text>
            <Select
              //   {...register(GENERAL_INFO.RELIGION)}
              options={[
                {
                  label: "label 1",
                  value: "label 1",
                },
                {
                  label: "label 1",
                  value: "label 1",
                },
                {
                  label: "label 1",
                  value: "label 1",
                },
                {
                  label: "label 1",
                  value: "label 1",
                },
                {
                  label: "label 1",
                  value: "label 1",
                },
              ]}
              defaultValue={"test"}
              name="building"
              onSelectItem={(e) => console.log(e)}
              suffix={<IconChevronDown size="16" />}
              placeholder={t(
                "INVENTORY_ROOM_CONFIG.FLOOR.FORM.FIELDS.FIELD_2.PLACEHOLDER",
              )}
            />
          </div>
          <div className="col-4">
            <Text
              color="#344054"
              component="p"
              size="md"
              weight="semibold"
              className="mb-6"
            >
              {t("INVENTORY_ROOM_CONFIG.FLOOR.FORM.FIELDS.FIELD_3.NAME")}
            </Text>
            <Select
              //   {...register(GENERAL_INFO.RELIGION)}
              options={[
                {
                  label: "label 1",
                  value: "label 1",
                },
                {
                  label: "label 1",
                  value: "label 1",
                },
                {
                  label: "label 1",
                  value: "label 1",
                },
                {
                  label: "label 1",
                  value: "label 1",
                },
                {
                  label: "label 1",
                  value: "label 1",
                },
              ]}
              defaultValue={"test"}
              name="noOfFloor"
              onSelectItem={(e) => console.log(e)}
              suffix={<IconChevronDown size="16" />}
              placeholder={t(
                "INVENTORY_ROOM_CONFIG.FLOOR.FORM.FIELDS.FIELD_3.PLACEHOLDER",
              )}
            />
          </div>
          <div className="col-4">
            <Text
              color="#344054"
              component="p"
              size="md"
              weight="semibold"
              className="mb-6"
            >
              {t("INVENTORY_ROOM_CONFIG.FLOOR.FORM.FIELDS.FIELD_4.NAME")}
            </Text>
            <Input
              name="text-input"
              onChange={function noRefCheck() {}}
              onSelectionChange={function noRefCheck() {}}
              outline={true}
              placeholder={t(
                "INVENTORY_ROOM_CONFIG.FLOOR.FORM.FIELDS.FIELD_4.PLACEHOLDER",
              )}
            />
          </div>
          <div className="align-self-end col-4">
            <Button
              fill="fill"
              onClick={(e) => console.log(e, "Add Button Clicked")}
              size="md"
              type="info"
              isPadding={false}
              className="px-20 py-5"
            >
              {t("INVENTORY_ROOM_CONFIG.FLOOR.FORM.ADD_BUTTON.BUTTON_TEXT")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
